import script from "./SearchList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchList.vue?vue&type=script&lang=ts&setup=true"

import "./SearchList.vue?vue&type=style&index=0&id=8f50a286&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f50a286"]])

export default __exports__